import { Component, EventEmitter, Inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'vex-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SnackbarComponent {
  @Input() message: string;
  @Input() type: 'success' | 'error' | 'warning' ;
  @Output() closeSnackbar = new EventEmitter<void>();
  
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    if (data) {
      this.message = data.message;
      this.type = data.type;
    }
  }
}
